/* KrakenTheMeta — load the Firebase compat SDK on demand (public pages ship without it).
 * KD.firebase.load(["database"]) → app + auth + firestore + app-check (+ extras), booted once via
 * KTMFirebase (same config and App Check as the rest of the site). KD.firebase.user() → the signed-in
 * user or null, once auth has settled.
 */
import "./ui.js";
import "../ktm-firebase.js";

(function () {
  "use strict";

  var KD = window.KD;
  if (KD.firebase) return;
  var BASE = "https://www.gstatic.com/firebasejs/9.5.0/firebase-";
  var loaded = {}, core = null;

  function script(name) {
    if (loaded[name]) return loaded[name];
    loaded[name] = new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = BASE + name + "-compat.js";
      s.onload = resolve;
      s.onerror = function () { loaded[name] = null; reject(new Error("Couldn't load " + name)); };
      document.head.appendChild(s);
    });
    return loaded[name];
  }

  KD.firebase = {
    load: function (extra) {
      if (!core) {
        core = script("app")
          .then(function () { return Promise.all([script("auth"), script("firestore"), script("app-check")]); })
          .then(function () { window.KTMFirebase.boot(); });
        core.catch(function () { core = null; });
      }
      return core.then(function () { return Promise.all((extra || []).map(script)); });
    },
    user: function () {
      return new Promise(function (resolve) {
        var off = window.firebase.auth().onAuthStateChanged(function (u) { off(); resolve(u || null); });
      });
    }
  };
})();
